import moment from 'moment';
import DTO from './DTO';

class CalendarDateDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'id',
        type: String,
        validators: {},
        labelKey: 'calendar.date.id',
      },
      {
        name: 'description',
        type: String,
        validators: [],
        labelKey: 'calendar.date.description',
      },
      {
        name: 'date',
        type: String,
        validators: [],
        labelKey: 'calendar.date.date',
      },
      {
        name: 'type',
        type: String,
        validators: [],
        labelKey: 'calendar.date.type',
      },
      {
        name: 'created_at',
        type: moment,
        validators: [],
        labelKey: 'created_at',
      },
      {
        name: 'updated_at',
        type: moment,
        validators: [],
        labelKey: 'updated_at',
      },
    ];
    super(attributes, params, isValidInit);
  }
}

export default CalendarDateDTO;
